import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import AddEditAgencyModal from './add-edit-agency';
import { getAgencies } from '../../actions/agency';
import { Table } from '../../common/components';

function EditButton({ agency = {} }) {
  const dispatch = useDispatch();

  function handleEditInfo() {
    dispatch({ type: 'OPEN_ADD_AGENCY' });
    dispatch({ type: 'SET_EDIT_AGENCY_INFO', payload: agency, edit: true });
  }

  return (
    <button
      type="button"
      className="btn btn-primary btn-link px-0 text-sky font-weight-bold"
      onClick={() => handleEditInfo()}
    >
      Edit
    </button>
  );
}



function Admin() {
  const dispatch = useDispatch();
  const agencies = useSelector(store => store.agencies.records);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const filteredAgencies = agencies.filter((agency) => agency.visible);

  // cell formatting
  const formatEditCell = (a) => <EditButton agency={a} />;

  useEffect(() => {
    setLoading(true);
    getAgencies()
      .catch(err => setErrorMessage(err))
      .finally(() => setLoading(false));
  }, []);

  const schema = {
    cols: [
      {
        header: 'Agent Group Name',
        field: 'name',
      },
      {
        header: 'Description',
        field: 'description',
      },
      {
        header: 'Contact Name',
        field: 'contact_name',
      },
      {
        header: 'Contact Phone',
        field: 'contact_phone',
      },
      {
        header: 'Contact Email',
        field: 'contact_email',
      },
      {
        header: '# Agents',
        field: 'agent_count',
      },
      {
        header: '',
        formatter: formatEditCell,
        passAllData: true,
      },
    ],
  };

  return (
    <main className="p-5">
      <div className="row">
        <div className="col">
          <h2 className="mb-3 font-weight-bold">Agent Groups</h2>
          <h5>Agent Groups are used for user access, campaign management and reporting purposes.</h5>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="border bg-white pt-5 h-100 shadow-sm">
            <div className="row mb-4">
              <div className="col d-flex">
                <div className="d-inline-block align-middle ms-5">
                  <input
                    placeholder="Search"
                    className="form-control border"
                    onChange={({ target }) => dispatch({ type: 'FILTER_AGENCIES', term: target.value })}
                  />
                </div>

                <div className="ms-auto me-4">
                  <button
                    type="button"
                    className="btn btn-secondary ms-2"
                    onClick={() => dispatch({ type: 'OPEN_ADD_AGENCY' })}
                  >
                    <FontAwesomeIcon icon={faPlus} size="lg" className="me-2" />
                    Create Agent Group
                  </button>
                </div>
              </div>
            </div>
            <Table
              schema={schema}
              data={filteredAgencies}
              loading={loading}
              className="table table-striped"
              errorMessage={errorMessage}
            />
          </div>
        </div>
      </div>

      <AddEditAgencyModal />
    </main>
  );
}

export default Admin;
